module.exports = __webpack_public_path__ + "img/world-education-logo.a9736067.webp";